/*******START LOAD MORE AND LOAD LESS******/
function seeAllClicked() {
    
    var gridElem = document.getElementsByClassName("rightWrapper")[0];
    var items = gridElem.getElementsByClassName("grid__item");
    for(var i = 0; i < items.length; i++) {
        items[i].style.display = "block";
    }
    var seeAllBtn = gridElem.getElementsByClassName("showAll")[0];
    seeAllBtn.style.display = "none";
    var seeLessBtn = gridElem.getElementsByClassName("showLess")[0];
    seeLessBtn.style.display = "block";
}
function seeLessClicked() {
    var gridElem = document.getElementsByClassName("rightWrapper")[0];
    var items1 = gridElem.getElementsByClassName("grid__item");
    for(var i = 18; i < items1.length; i++) {
        items1[i].style.display = "none";
    }
    var seeAllBtn = gridElem.getElementsByClassName("showAll")[0];
    seeAllBtn.style.display = "block";
    var seeLessBtn = gridElem.getElementsByClassName("showLess")[0];
    seeLessBtn.style.display = "none";
}
/*******END LOAD MORE AND LOAD LESS******/

/*******start add sticky to lock the left the content on shop page*******/
window.addEventListener('scroll', function() {
    var lastScrollTop = 0;
    
    var scrollLive = window.pageYOffset || document.documentElement.scrollTop;

    var collectionWrapper = document.getElementById("collectionWrapper");
    
    if (scrollLive > lastScrollTop) {
      if(collectionWrapper){
        document.getElementById("collectionWrapper").classList.add("sticky");
      }
    } else {
      
      if(collectionWrapper){
          document.getElementById("collectionWrapper").classList.remove("sticky");
        }
    }
});
/*******start add sticky to lock the left the content on shop page*******/

filterSelection("all")
function filterSelection(c) {
  var x, i;
  x = document.getElementsByClassName("category");
  //if (c == "all") c = "";
  // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
  for (i = 0; i < x.length; i++) {
    w3RemoveClass(x[i], "show");
    if (x[i].className.indexOf(c) > -1) w3AddClass(x[i], "show");
  }
}

// Show filtered elements
function w3AddClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {
      element.className += " " + arr2[i];
    }
  }
}

// Hide elements that are not selected
function w3RemoveClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(" ");
  arr2 = name.split(" ");
  for (i = 0; i < arr2.length; i++) {
    while (arr1.indexOf(arr2[i]) > -1) {
      arr1.splice(arr1.indexOf(arr2[i]), 1); 
    }
  }
  element.className = arr1.join(" ");
}

// Add active class to the current control button (highlight it)
var btnContainer = document.getElementById("filterTab");
if (btnContainer !== null){
  var btns = btnContainer.getElementsByClassName("tab-link");
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function() {
      console.log("clicked");
      var current = document.getElementsByClassName("active");
      current[0].className = current[0].className.replace(" active", "");
      this.className += " active";
    });
  }
}
// blog post filter tab slider
var swiper = new Swiper(".filterTabSlider", {
  loop: false,
  slidesPerView: "auto",
  speed: 2000,
  simulateTouch: true,
  draggable: true,
  allowTouchMove: true,
  navigation: {
    nextEl: '.filter-button-next',
    prevEl: '.filter-button-prev',
  }        
});

/******collection filter*****/
function collectionFilter() {
  var element = document.getElementById("filter");
  var body = document.getElementById("bodyWrapper");
  element.classList.toggle("open");
  body.classList.toggle("open");
}

/******product gallery*****/
var galleryThumbs = new Swiper('.product-gallery-thumbs', {
  spaceBetween: 8,
  slidesPerView: 5,
  loop: false,
});

var ss100 = new Swiper('.desktop_slider', {      
loop: true,
speed: 2000,
spaceBetween: 10,
slidesPerView: 1,
navigation: {
  prevEl: '.product-gallery-next',
  nextEl: '.product-gallery-prev',
},
thumbs: {
  swiper: galleryThumbs,
}
});

var ss100 = new Swiper('.mobile_slider', {      
  loop: false,
  speed: 2000,
  slidesPerView: 1,
  navigation: {
    prevEl: '.product-gallery-next',
    nextEl: '.product-gallery-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'custom',
    renderCustom: function (swiper, current, total) {
       return ('0' + current).slice(-2) + ' / ' + ('0' + total).slice(-2);
    }
  }
  });